import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { NB_DocPlaceSignModule_props } from "./type/docplace_tree_file.types";
import useAxios from "./hook/hook";
import {
  DPwrapperTree,
  DPwrapperTreeHeader,
  DPwrapperTreeBodyR,
  DPwrapperTreeBodyL,
  DPwrapperTreeBodyRTitle,
  DPwrapperTreeBodyRLI,
  DPwrapperTreeBodyRUL,
} from "./style/docplace_tree_file.styles";
/* eslint-disable react/jsx-pascal-case -- Nb_HorizontalMenu is legacy component name */
import { Nb_HorizontalMenu } from "../../components/horizontalMenu/horizontalMenu";
import TreeItems from "./tree";
import { useNavigate } from "react-router-dom";
import LoadingComponent from "../../components/loading";
import closeSmallIcon from "../../assets/svg/CloseSmallIcon.svg";
import fileIconTree from "../../assets/svg/fileIconTree.svg";
import Button from "@mui/material/Button";
import { toast, ToastContainer } from "react-toastify";

import FileUpload from "../../DocPlace/DocplaceSign_Module/upload/fileUpload.js";

import { uploadFileManual } from "../../services/FileUploadService";

const NbTreeFile: React.FC<NB_DocPlaceSignModule_props> = (props) => {
  useDispatch();
  useNavigate();
  const [mapPath, setMapPath] = useState<any>([]);
  const [filesSign, setFilesSign] = useState<any>([]);
  const { fetchTree, dataTree, setParentFolderId, treeLoading } = useAxios();
  const [uploaded, setUploaded] = React.useState(false);
  const notify = (
    msj: string,
    event: "success" | "error" | "info" | "warning"
  ) => toast[event](msj);

  useEffect(() => {
    fetchTree(
      "/automation/api/v1.0/Archives/TreeResource?hideReservedFolder=false&parentArchiveId=&direction="
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps -- initial fetch only
  }, []);

  const onClickTree = (item: any) => {
    console.log("onClickTree", item);
    if (item.type === "Folder" || item.folder === true) {
      setParentFolderId(item.value);
      fetchTree(
        `/automation/api/v1.0/Archives/TreeResource?hideReservedFolder=false&parentArchiveId=${item.value}&direction=`
      );
      const nextMap = [
        ...mapPath,
        {
          name: item.label,
          id: item.value,
          parent: !item.label ? "" : item.parent ? item.parent.id : "",
          type: item.type,
        },
      ];
      setMapPath(nextMap);
    } else {
      console.log("onClickTree else", item);
      console.log("filesSign", filesSign);
      setFilesSign((prevFiles: { id: string; label: string }[]) => {
        const exists = prevFiles.some((f) => f.id === item.value);
        if (exists) return prevFiles;
        return [...prevFiles, { id: item.value, label: item.label }];
      });
    }
  };

  const onClickBackTree = (item: any) => {
    let newMap: any = [];
    let end = mapPath.length;
    let origin = mapPath[mapPath.length - 1].parent;
    mapPath.forEach((map: any) => {
      if (map.id !== mapPath[end - 1].id) {
        newMap.push(map);
      }
    });
    setMapPath(newMap);
    setParentFolderId(
      newMap.length > 0 ? newMap[newMap.length - 1].id : origin
    );
    fetchTree(
      `/automation/api/v1.0/Archives/TreeResource?hideReservedFolder=false&parentArchiveId=${item.value}&direction=UP`
    );
  };

  const removeFile = (fileId: string) => {
    setFilesSign((prevFiles: { id: string; label: string }[]) =>
      prevFiles.filter((file) => file.id !== fileId)
    );
  };

  const refreshTree = (item: any, documentId: string, name: string) => {
    fetchTree(
      `/automation/api/v1.0/Archives/TreeResource?hideReservedFolder=false&parentArchiveId=${item}&direction=`
    );

    setFilesSign([...filesSign, { id: documentId, label: name }]);
  };

  const handleFileSelect = (file: any) => {
    console.log("handleFileSelect", file);
    if (mapPath.length >= 0) {
      setUploaded(true);
      uploadFileManual(
        file,
        true,
        null,
        mapPath.length > 0 ? mapPath[mapPath.length - 1].id : "",
        true,
        "replace"
      )
        .then((response) => {
          setUploaded(false);
          refreshTree(
            mapPath.length > 0 ? mapPath[mapPath.length - 1].id : "",
            response?.data.documentId,
            file.name
          );
          notify(file.name + " uploaded", "success");
        })
        .catch((err) => {
          setUploaded(false);
          toast.error(err?.response?.data?.error?.messages[0].message);
        })
        .finally(() => {});
    }
  };

  return (
    <DPwrapperTree>
      <ToastContainer autoClose={3000} />
      <LoadingComponent
        show={treeLoading || uploaded === true}
        text={"Loading..."}
      />
      <DPwrapperTreeHeader>Document selection</DPwrapperTreeHeader>
      <DPwrapperTreeBodyL>
        <div style={{ width: "90%", height: "36px", margin: "12px 0 0 14px" }}>
          <Nb_HorizontalMenu
            menus={[{ id: "1", name: "File Manager", active: true, route: "" }]}
            onClickMenu={props.onClickMenu}
          />
        </div>
        <TreeItems
          click={onClickTree}
          backTree={onClickBackTree}
          tree={dataTree || []}
          treePrevius={mapPath}
          hideTrash={true}
        />
      </DPwrapperTreeBodyL>
      <DPwrapperTreeBodyR>
        <DPwrapperTreeBodyRTitle>Files Selected</DPwrapperTreeBodyRTitle>
        <DPwrapperTreeBodyRUL>
          {filesSign.length === 0 && (
            <DPwrapperTreeBodyRLI>
              <span style={{ marginLeft: "8px" }}>No files selected yet</span>
            </DPwrapperTreeBodyRLI>
          )}
          {filesSign.map((file: any, idx: number) => {
            return (
              <DPwrapperTreeBodyRLI key={idx}>
                <img
                  src={fileIconTree}
                  style={{
                    left: "0px",
                    top: "-4px",
                    margin: "10px 12px 0px 0px",
                    position: "absolute",
                  }}
                  alt=""
                />
                <span
                  style={{
                    left: "20px",
                    top: "-4px",
                    margin: "6px 12px 0px 0px",
                    position: "absolute",
                  }}
                >
                  {file.label}
                </span>
                <img
                  onClick={() => removeFile(file.id)}
                  src={closeSmallIcon}
                  style={{
                    right: "0",
                    top: "-4px",
                    margin: "7px 12px 0px 0px",
                    position: "absolute",
                  }}
                  alt=""
                />
              </DPwrapperTreeBodyRLI>
            );
          })}
        </DPwrapperTreeBodyRUL>
        <div style={{ marginTop: "12px" }}>
          <FileUpload onFileSelect={handleFileSelect} />
        </div>
        <div style={{ position: "absolute", bottom: "15px", right: "115px" }}>
          <Button
            onClick={props.onClickClose}
            size="small"
            color="primary"
            variant="outlined"
          >
            <span>Cancel</span>
          </Button>
        </div>
        <div style={{ position: "absolute", bottom: "15px", right: "10px" }}>
          <Button
            disabled={filesSign.length === 0}
            size="small"
            color="primary"
            variant="contained"
            onClick={() => {
              props.onClickRequest?.(filesSign);
            }}
          >
            <span>Continue</span>
          </Button>
        </div>
      </DPwrapperTreeBodyR>
    </DPwrapperTree>
  );
};

export default NbTreeFile;
